
import "./Quizzes.css"
import img1 from "../../Images/UNSMoodleLogin.png"
import img2 from "../../Images/UNSMyCourses.png"
import img3 from "../../Images/UNSEditMode.png"
import img4 from "../../Images/UNSAddResource.png"
import img5 from "../../Images/UNSMeetMoodle.png"
import img6 from "../../Images/UNSRoomD1.png"
import img7 from "../../Images/UNSRoomD2.png"
import img8 from "../../Images/ActivityGen2.png"
import img9 from "../../Images/QuizP1.png"
import img10 from "../../Images/QuizP3.png"
import img11 from "../../Images/Quizp4.png"
import img12 from "../../Images/Quizp5.png"
import img13 from "../../Images/Quizp6.png"
import img14 from "../../Images/Quizp7.png"
import img15 from "../../Images/Quizp8.png"
import img16 from "../../Images/Quizp9.png"
import img17 from "../../Images/Quizp10.png"

// import { Outlet } from "react-router-dom";


function Quizzes() {
    return (
      <div className="QuizzesCover"> 

            <h1>Quiz Guide </h1>

            <div className="ContentOutput">
                      <div className="Hyperlinks">
                          <ul>
                              <li><a href="#Section1"> Introduction to moodle</a>  </li>
                              <li><a href="#Section2"> How to find my Quizzes</a>  </li>
                              <li><a href="#Section3"> How to take a Quiz </a> </li>
                              {/* <li><a href="#Section3"> Moodle Quiz structure </a> </li> */}
                              <li><a href="#Section4"> How to continue an open Quiz</a> </li>
                            
                          </ul>

                      </div>
                      <div className="resourceSection">
                      
                      <section id="Section1">

                            <div className="contentWhole">  

                                  <div className="contentHeading">  
                                        <h3>Introduction to Moodle</h3>
                                        </div>
                                              <div className="contentParagraph"> 

                                                  <p> 
                                                      Moodle is the online learning platform used by Unilus. It contains individual spaces for each of your modules, where you can access a variety of information, materials, and activities. 
                                                  </p>    
                                                  <p> 
                                                    Almost all taught modules have a Moodle space.

                                                  </p>    

                                            </div>
                                  <div className="contentImage">  

                                 </div>


                            </div>


                      </section>

                      <section id="Section2">

                      <div className="contentWhole">  

                        <div className="contentHeading">  
                              <h2>How to find active Quizzes</h2>
                              </div>
                                    <div className="contentParagraph"> 

                                    <p> 
                                          <b> STEP 1 :</b> Navigate to My courses
                                    </p>    
                                    <p> 
                                          {/* Almost all taught modules have a Moodle space. */}

                                    </p>    

                              </div>
                        <div className="contentImage">  
                        <img src={img2} />

                        </div>
                                    <div className="contentParagraph"> 

                                    <p> 
                                    <b>
                                          STEP 2 : </b>Go to the respective course with the Quiz
                                    </p>    
                                    <p> 
                                          {/* Almost all taught modules have a Moodle space. */}

                                    </p>    

                              </div>
                        <div className="contentImage">  
                        <img src={img4} />

                        </div>
                                    <div className="contentParagraph"> 

                                    <p> 
                                          <b>STEP 3 :</b> Scroll through the course resources looking for Activity titles like <b>"LINK TO QUIZ"</b> and click on it
                                    </p>    
                                    <p> 
                                          {/* Almost all taught modules have a Moodle space. */}

                                    </p>    

                              </div>
                        <div className="contentImage">  
                        <img src={img8} />

                        </div>

                              



                        </div>




                      </section>
                      <section id="Section3">

                      <div className="contentWhole">  

                        <div className="contentHeading">  
                              <h2>How to take a Quiz</h2>
                              </div>
                                    <div className="contentParagraph"> 

                                    <p> 
                                          <b> STEP 1 :</b> Navigate to My courses
                                    </p>    
                                    <p> 
                                          {/* Almost all taught modules have a Moodle space. */}

                                    </p>    

                              </div>
                        <div className="contentImage">  
                        <img src={img2} />

                        </div>
                                    <div className="contentParagraph"> 

                                    <p> 
                                    <b>
                                          STEP 2 : </b>Go to the respective course with the Quiz
                                    </p>    
                                    <p> 
                                          {/* Almost all taught modules have a Moodle space. */}

                                    </p>    

                              </div>
                        <div className="contentImage">  
                        <img src={img4} /> 
                        

                        </div>
                                    <div className="contentParagraph"> 

                                    <p> 
                                          <b>STEP 3 :</b> Scroll through the course resources looking for Activity titles like <b>"LINK TO QUIZ"</b> and click on it
                                    </p>    
                                    <p> 
                                          {/* Almost all taught modules have a Moodle space. */}

                                    </p>    

                              </div>
                        <div className="contentImage">  
                        <img src={img9} />

                        </div>
                                    <div className="contentParagraph"> 

                                    <p> 
                                          <b>STEP 4 :</b>  Navigate to <b>"Attempt quiz"</b> and click on it
                                    </p>    
                                    <p> 
                                          {/* Almost all taught modules have a Moodle space. */}

                                    </p>    

                              </div>
                        <div className="contentImage">  
                        <img src={img10} />

                        </div>
                                    <div className="contentParagraph"> 

                                    <p> 
                                          <b>STEP 5 :</b> Click on <b>"Attempt quiz"</b> and click on it
                                    </p>    
                                    <p> 
                                          {/* Almost all taught modules have a Moodle space. */}

                                    </p>    

                              </div>
                        <div className="contentImage">  
                        <img src={img11} />

                        </div>
                                    <div className="contentParagraph"> 

                                    <p> 
                                          <b>STEP 6 :</b> Enter the Quiz (Will be provided) then click on <b>"START ATTEMPT"</b>
                                    </p>    
                                    <p> 
                                          {/* Almost all taught modules have a Moodle space. */}

                                    </p>    

                              </div>
                        <div className="contentImage">  
                        <img src={img12} />

                        </div>
                                    <div className="contentParagraph"> 

                                    <p> 
                                          <b>STEP 7 :</b> You can now take the quiz in order your prefer
                                    </p>    
                                    <p> 
                                          {/* Almost all taught modules have a Moodle space. */}

                                    </p>    

                              </div>
                        <div className="contentImage">  
                        <img src={img13} />

                        </div>
                                    <div className="contentParagraph"> 

                                    <p> 
                                          <b>STEP 8 :</b> Check the time remaining and Attempted at the top right corner of your screen
                                    </p>    
                                    <p> 
                                          {/* Almost all taught modules have a Moodle space. */}

                                    </p>    

                              </div>
                        <div className="contentImage">  
                        <img src={img14} />

                        </div>
                                    <div className="contentParagraph"> 

                                    <p> 
                                          <b>STEP 9 :</b> Navigate to the next questions by clicking on <b>"Next page"</b> at the bottom right of your screen
                                    </p>    
                                    <p> 
                                          {/* Almost all taught modules have a Moodle space. */}

                                    </p>    

                              </div>
                        <div className="contentImage">  
                        <img src={img15} />

                        </div>
                                    <div className="contentParagraph"> 

                                    <p> 
                                          <b>STEP 10 :</b> Finish your Attempt by clicking <b>"Finish Attempt"</b> at the bottom right of your screen
                                    </p>    
                                    <p> 
                                          {/* Almost all taught modules have a Moodle space. */}

                                    </p>    

                              </div>
                        <div className="contentImage">  
                        <img src={img16} />

                        </div>
                                    <div className="contentParagraph"> 

                                    <p> 
                                          <b>STEP 11 :</b> A screen will open with the status of your now previous Quiz
                                    </p>    
                                    <p> 
                                          {/* Almost all taught modules have a Moodle space. */}

                                    </p>    

                              </div>
                        <div className="contentImage">  
                        <img src={img17} />

                        </div>

                              



                        </div>




</section>
      <section id="Section4">

     

   

      </section>
      <section id="Section4">

     


      </section>



                      </div>
                </div>
     
      </div>
    );
  }
  
  export default Quizzes;
  